import { ScoreInfoType } from '../constants-types/Enums';
import { ABCD } from '../core-data-model/BehavioralFactor.model';
import { Pattern, FullPattern } from '../core-data-model/Pattern.model';
import { SigmaScore } from '../core-data-model/SigmaScore.interface';

export interface PatternInputData {
    selfSigmaScore: SigmaScore;
    selfConceptSigmaScore?: SigmaScore;
    synthesisSigmaScore?: SigmaScore;
}

export class PatternTransformer {
    static makePattern(
        source: SigmaScore | null,
        scoreType: ScoreInfoType
    ): Pattern {
        const pattern = new Pattern();
        if (source) {
            pattern.A = source.aSigma;
            pattern.B = source.bSigma;
            pattern.C = source.cSigma;
            pattern.D = source.dSigma;
            pattern.E = source.eSigma;
            pattern.M = source.mScore;
        }
        pattern.type = scoreType;
        return pattern;
    }

    /**
     * Transforms server pattern data to client data structure.
     *
     * Returns null if the pattern data is not available.
     *
     * @param data
     */
    static transformToFullPattern(
        data: PatternInputData,
        scoreId?: string
    ): FullPattern | null {
        if (!data || !data.selfSigmaScore) {
            return null;
        }

        const fullPattern = new FullPattern();
        fullPattern.self = PatternTransformer.makePattern(
            data.selfSigmaScore,
            ScoreInfoType.Self
        );
        fullPattern.selfConcept = PatternTransformer.makePattern(
            data.selfConceptSigmaScore,
            ScoreInfoType.SelfConcept
        );
        fullPattern.synthesis = PatternTransformer.makePattern(
            data.synthesisSigmaScore,
            ScoreInfoType.Synthesis
        );

        fullPattern.scoreId = scoreId;

        return fullPattern;
    }

    static averagePatterns(patterns: Pattern[]): Pattern {
        const averagedPattern = patterns.reduce(
            (a, b) =>
                new Pattern({
                    A: a.A + b.A,
                    B: a.B + b.B,
                    C: a.C + b.C,
                    D: a.D + b.D
                }),
            new Pattern({
                A: 0,
                B: 0,
                C: 0,
                D: 0
            })
        );

        ABCD.forEach(
            (factor) =>
                (averagedPattern[factor] =
                    averagedPattern[factor] / patterns.length)
        );
        return averagedPattern;
    }
}
